import {
    Flex, Heading, HStack, Link, SimpleGrid, Spinner, Text,
} from '@chakra-ui/react';
import { useBrowserTitle } from '@acp/core-ui';
import { useAutoLoginRedirect, useSystemStates } from '@acp/feature/auth';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoginStateButton } from '../components/buttons';

function LoginStateList() {
    const {
        data, isLoading, isError,
    } = useSystemStates();

    if (isLoading || isError || data === undefined) {
        return (
            <SimpleGrid minChildWidth="150px" spacing={5} width="100%">
                <LoginStateButton.Skeleton />
                <LoginStateButton.Skeleton />
                <LoginStateButton.Skeleton />
                <LoginStateButton.Skeleton />
                <LoginStateButton.Skeleton />
            </SimpleGrid>
        );
    }

    return (
        <SimpleGrid minChildWidth="150px" spacing={5} width="100%">
            {data.map((state) => (
                <LoginStateButton
                    key={state.shortName}
                    complianceStateId={state.complianceStateId}
                    stateShortName={state.shortName}
                />
            ))}
        </SimpleGrid>
    );
}

export function AuthLogin() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    useBrowserTitle('Login');

    const {
        isLoading,
        isRedirectingToLogin,
    } = useAutoLoginRedirect({
        stateId: params.get('__acp_state_id'),
        redirect: params.get('redirect'),
        onAlreadyLoggedIn: (url) => {
            navigate(url, {
                replace: true,
            });
        },
    });

    if (isLoading || isRedirectingToLogin) {
        return (
            <Flex flexDir="column" width="100%">
                <Flex width="100%" alignItems="center" mb={6}>
                    <Heading fontSize="3xl" flexGrow={1}>
                        We&apos;re signing you in...
                    </Heading>
                    <Spinner />
                </Flex>
                <Text fontSize="lg">Please wait while we verify your details</Text>
            </Flex>
        );
    }

    return (
        <Flex flexDir="column" alignItems="start" width="100%" pt={[0, 2]}>
            <Heading fontSize="3xl" mb={4}>
                Select your state
            </Heading>
            <Text fontSize="lg" mb={10}>
                Once you select your state, you will be required to login to your account
            </Text>
            <LoginStateList />

            <HStack pt={5} gap={5}>
                <Link href="https://detectorinspector.formcrafts.com/portal-access" target="_blank">
                    Need access?
                </Link>

                <Link href="https://detectorinspector.formcrafts.com/portal-access" target="_blank">
                    Forgot username?
                </Link>
            </HStack>
        </Flex>
    );
}
